module.exports = __webpack_public_path__ + "media/assets/img/pages/login-fd58a052054c690506118c4b7a0f731d.png";